import { useQuery } from '@apollo/client';
import { Inline, Text } from 'braid-design-system';
import React from 'react';

import { GetIndustryDisplayNameByIdsDocument } from 'src/generated/graphql';

interface IndustryProps {
  industries: Array<{
    id: string;
    title: string;
    urlKey: string;
  }>;
}

export const Industry = ({ industries }: IndustryProps) => {
  const { loading, data } = useQuery(GetIndustryDisplayNameByIdsDocument, {
    variables: { industryIds: industries.map((i) => i.id) },
  });

  if (loading && !data) {
    return null;
  }
  return (
    <Inline space="xsmall">
      <Text weight="strong">Industry:</Text>
      <Text>{data?.getIndustryDisplayNameByIds}</Text>
    </Inline>
  );
};
